import { Component, EventEmitter, Output } from '@angular/core';
import { AcqnFiltersDetails } from '../../model/AcqnFiltersDetails';
import { AcqnFilterService } from 'src/app/services/acqn-filter-service';
import { AppConstants } from 'src/app/shared/app.constants';
import { FilterDetailsSourceType } from 'src/app/shared/enum-value';

@Component({
  standalone: false,
  selector: 'app-acquisitions-insurance-filter',
  templateUrl: './acquisitions-insurance-filter.component.html',
  styleUrl: './acquisitions-insurance-filter.component.css'
})
export class AcquisitionsInsuranceFilterComponent {

  ACQUISITION_STATUS_LIST = [
    {
      label: "All",
      value: "",
    },
    {
      label: "Acquired",
      value: "Acquired",
    },
    {
      label: "Committed",
      value: "Pre-Acquisition",
    },
  ];

  SUPPLEMENTAL_LIST = [
      {
        label: "All",
        value: "",
      },
      {
        label: "-- Not Provided --",
        value: null,
      },
      {
        label: "Y",
        value: "Y",
      },
      {
        label: "N",
        value: "N",
      },
    ]

    LOAD_REFINANCE_TYPE_LIST = [
      {
        label: "All",
        value: "",
      },
      {
        label: "-- Not Provided --",
        value: null,
      },
      {
        label: "N/A",
        value: "N/A",
      },
      {
        label: "Standard Refinance",
        value: "Standard Refinance",
      },
      {
        label: "Choice Refinance",
        value: "Choice Refinance",
      },
    ]

    SMALL_LOAN_BALANCE_LIST = [
      {
        label: "All",
        value: "",
      },
      {
        label: "-- Not Provided --",
        value: null,
      },
      {
        label: "N",
        value: "N",
      },
      {
        label: "Y",
        value: "Y",
      },
    ]

    TRANSACTION_TYPE_LIST = [
      {
        label: "All",
        value: "",
      },
      {
        label: "Flow",
        value: "Flow",
      },
      {
        label: "Structured",
        value: "Structured",
      },
    ]

    REQUIRE_FLOOD_INSURANCE_LIST = [
      {
        label: "All",
        value: "",
      },
      {
        label: "N",
        value: "N",
      },
      {
        label: "Y",
        value: "Y",
      },
    ]

  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  acqnFiltersDetails: AcqnFiltersDetails = {
    source: '',
    isInternal: false,
    openAcqnFilterSidebar: false,
    startPeriod: '',
    endPeriod: '',
    lender: '',
    acquisitionStatus: '',
    supplemental: '',
    loanRefinanceType: '',
    smallLoanBalance: '',
    transactionType: '',
    requireFloodINS: '',
    lenderList: [],
    acquisitionStatusList: [],
    supplementalList: [],
    loanRefinanceTypeList: [],
    smallLoanBalanceList: [],
    transactionTypeList: [],
    requireFloodINSList: []
  }

  selectStartPeriod: any[] = [];
  selectEndPeriod: any[] = [];

  monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

  isAcqnOption: boolean = false;
  isLenderRankingOption: boolean = false;
  isDataFileOption: boolean = false;

  constructor(private acqnFiltersService: AcqnFilterService) {}

  ngOnInit() {
    this.acqnFiltersService.acqnInsuranceFiltersDetailsSub.subscribe((acqnFiltersDetails: AcqnFiltersDetails) => {
      console.log("acquisitions-insurance-filter.component.ts::ngOnInit - call acqnInsuranceFiltersDetailsSub.subscribe ");

      if (!acqnFiltersDetails.source.includes(FilterDetailsSourceType.AcqnInsuranceFilter)) {

        // Decide what to display based on the source location
        this.isAcqnOption = false;
        this.isLenderRankingOption = false;
        this.isDataFileOption = false;

        if (acqnFiltersDetails.source == FilterDetailsSourceType.INSAcq)
          this.isAcqnOption = true;

        if (acqnFiltersDetails.source == FilterDetailsSourceType.INSLenderRanking)
          this.isLenderRankingOption = true;

        if (acqnFiltersDetails.source == FilterDetailsSourceType.INSDataFiles)
          this.isDataFileOption = true;

        this.acqnFiltersDetails.source = acqnFiltersDetails.source;
        this.acqnFiltersDetails.isInternal = acqnFiltersDetails.isInternal;
        this.acqnFiltersDetails.startPeriod = acqnFiltersDetails.startPeriod;
        this.acqnFiltersDetails.endPeriod = acqnFiltersDetails.endPeriod;
        this.acqnFiltersDetails.lender = acqnFiltersDetails.lender;
        this.acqnFiltersDetails.acquisitionStatus = acqnFiltersDetails.acquisitionStatus;
        this.acqnFiltersDetails.supplemental = acqnFiltersDetails.supplemental;
        this.acqnFiltersDetails.loanRefinanceType = acqnFiltersDetails.loanRefinanceType;
        this.acqnFiltersDetails.smallLoanBalance = acqnFiltersDetails.smallLoanBalance;
        this.acqnFiltersDetails.transactionType = acqnFiltersDetails.transactionType;
        this.acqnFiltersDetails.lenderList = acqnFiltersDetails.lenderList;
        this.acqnFiltersDetails.requireFloodINS = acqnFiltersDetails.requireFloodINS;

        this.acqnFiltersDetails.acquisitionStatusList = this.ACQUISITION_STATUS_LIST;
        this.acqnFiltersDetails.supplementalList = this.SUPPLEMENTAL_LIST;
        this.acqnFiltersDetails.loanRefinanceTypeList = this.LOAD_REFINANCE_TYPE_LIST;
        this.acqnFiltersDetails.smallLoanBalanceList = this.SMALL_LOAN_BALANCE_LIST;
        this.acqnFiltersDetails.transactionTypeList = this.TRANSACTION_TYPE_LIST;
        this.acqnFiltersDetails.requireFloodINSList = this.REQUIRE_FLOOD_INSURANCE_LIST;

        this.calculateStartAndEndPeriods();
      }
    });
  }

  getCurrentDate() {
    return new Date();
  }

  calculateStartAndEndPeriods() {
    this.setStartPeriodDates();
    this.setEndPeriodDates();
  }

  setStartPeriodDates() {
    this.selectStartPeriod = [];

    let startDate = new Date(AppConstants.START_PERIOD_DD); // Start from October 2020
    let currentDate = this.getCurrentDate(); // Current date
    let futureDate = new Date(currentDate); // Clone current date
    futureDate.setMonth(futureDate.getMonth() + 13); // Add 12/13 months to current date

    let months = [];

    // Loop from startDate to futureDate
    while (startDate <= futureDate) {
        let monthName = this.monthNames[startDate.getMonth()];
        let year = startDate.getFullYear();

        // Exclude September 2020
        if (!(monthName === 'September' && year === 2020)) {
            months.push(monthName + ' ' + year);
        }

        startDate.setMonth(startDate.getMonth() + 1); // Move to the next month
    }

    // Populate selectStartPeriod with label and value
    for (let i = 0; i < months.length; i++) {
        this.selectStartPeriod.push({ label: months[i], value: months[i] });
    }
  }

  onShowSelectionChange() {

  }

  setEndPeriodDates() {
    this.selectEndPeriod = [];

    // Determine the start date
    let startDate = this.acqnFiltersDetails.startPeriod
      ? new Date(this.acqnFiltersDetails.startPeriod)
      : new Date(AppConstants.START_PERIOD_DD);

    // Calculate the end date (current date + 12/13 months)
    const endDate = this.getCurrentDate();
    endDate.setMonth(endDate.getMonth() + 13);

    // Generate month-year values from startDate to endDate
    const months = [];
    const date = new Date(startDate);

    while (date <= endDate) {
      const monthYear = `${this.monthNames[date.getMonth()]} ${date.getFullYear()}`;
      months.push(monthYear);
      date.setMonth(date.getMonth() + 1); // Move to the next month
    }

    // Add an empty option at the end
    this.selectEndPeriod.push({ label: "", value: "" });

    // Populate this.selectEndPeriod with the generated months
    for (const month of months) {
      this.selectEndPeriod.push({ label: month, value: month });
    }
  }

  onClickApplyFilters() {
    this.acqnFiltersDetails.source = this.acqnFiltersDetails.source + " - " + FilterDetailsSourceType.AcqnInsuranceFilter;
    this.acqnFiltersService.updateAcqnInsuranceFilters(this.acqnFiltersDetails);
    this.closeSidebar.emit(true);
  }

  onClickResetFilters() {
    let tempDate = this.getCurrentDate();
    this.acqnFiltersDetails.startPeriod = 'January ' + tempDate.getFullYear();
    this.acqnFiltersDetails.endPeriod = '';
    this.acqnFiltersDetails.lender = '';
    this.acqnFiltersDetails.acquisitionStatus = '';
    this.acqnFiltersDetails.supplemental = '';
    this.acqnFiltersDetails.loanRefinanceType = '';
    this.acqnFiltersDetails.smallLoanBalance = '';
    this.acqnFiltersDetails.transactionType = '';
    this.acqnFiltersDetails.requireFloodINS = '';

    this.calculateStartAndEndPeriods();
  }

  onClickCloseSidebar() {
    this.closeSidebar.emit(true);
  }
}
